
const Redirect = () => {
    window.location.replace(process.env.REACT_APP_SISURL !== undefined ? process.env.REACT_APP_SISURL : '');
    return <>Redirecting...</>;
  };
  
  export default Redirect;
  